import { useEffect as t } from "react";
const u = (e) => {
  t(() => {
    document && (document.title = e);
  }, [e]);
};
export {
  u as default
};
//# sourceMappingURL=useDocumentTitle.js.map
